var _rect, _rect2, _path, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingDemoVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lp7",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#f1f5f9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 36,
    height: 28,
    rx: 4,
    fill: "url(#lp7)",
    opacity: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 26l12 6-12 6V26z",
    fill: "#fff",
    opacity: 0.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 14,
    height: 3,
    rx: 1,
    fill: "#fff",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingDemoVideo);
export default __webpack_public_path__ + "static/media/landing-demo-video.391a3dfa5136c9bf6624b45531bd86eb.svg";
export { ForwardRef as ReactComponent };